export const NEXT_STATUS: Record<string, string | undefined> = {
  received: "accepted",
  accepted: "preparing",
  preparing: "ready",
  ready: "picked_up",
  picked_up: "delivered",
};
